import { formatISO, setHours, setMinutes, startOfDay } from "date-fns";

// A proposed date as the composer's schedule enters it: the day plus "HH:mm" times
export type ProposalFields = {
  date: string | null;
  time: string | null;
  time_end: string | null;
};

// The day at a "HH:mm" time, in the browser's time zone
export function atTime(date: string, time?: string | null) {
  const [hours, minutes] = (time || "00:00").split(":").map(Number);
  return formatISO(
    setMinutes(setHours(startOfDay(new Date(date)), hours || 0), minutes || 0),
  );
}

// Start and end as the server stores them; the end lies on the proposed day
export function proposalTimes({ date, time, time_end }: ProposalFields) {
  return {
    starts_at: date ? atTime(date, time) : null,
    ends_at: date && time_end ? atTime(date, time_end) : null,
  };
}
